import { useFetchLeadHistoryQuery } from "../../../../../../redux/queries"
import { Lead } from "../../../../../../types"
import LeadHistoryItem from "./lead-history-item"
import If from "../../../../if"
import { ActivityHistorySkeleton } from "../../../../skeletons"

interface Props {
  data: Lead
}

const LeadActivityPage = ({ data }: Props) => {
  const { data: leadHistory, isFetching } = useFetchLeadHistoryQuery(data.id, {
    skip: !data.id
  })

  return (
    <div className="max-w-2xl">
      <If
        condition={isFetching}
        then={<ActivityHistorySkeleton rows={3} className="mt-3" />}
        elseCondition={leadHistory && leadHistory?.length > 0}
        else={
          <>
            {leadHistory?.map((item, idx) => (
              <LeadHistoryItem
                key={item.id}
                data={item}
                connectorVisible={idx < leadHistory.length - 1}
              />
            ))}
          </>
        }
        default={<div className="">No activities found.</div>}
      />
    </div>
  )
}

export default LeadActivityPage
